/* eslint-disable sonarjs/no-duplicate-string */

import { defineMessages } from "react-intl";
import { useMessages } from "2g-hooks/intl";

const MESSAGES = defineMessages({
  widgetLabel: {
    id: "b2b.provozni-informace-posledni-widget.label",
    defaultMessage: "Last operational information"
  },
  cardNext: {
    id: "b2b.provozni-informace-posledni-widget.cardNext",
    defaultMessage: "NEXT"
  }
});

export default () => useMessages(MESSAGES);
